import { buildApiUrl } from 'config/environment'
import { getUserCachedData } from './UserAuthorization'

// Manda os erros da tela para o servidor (Administração Global › Erros do sistema).
// Usa fetch direto, sem a tela de carregamento, e nunca lança: reportar não pode quebrar nada.
const vistos = new Set()
const IGNORAR = /ResizeObserver loop|Script error\.?$|Loading chunk|ChunkLoadError/i

export function registrarErro(erro, detalhe) {
  try {
    if (process.env.NODE_ENV === 'test') return
    const mensagem = String(erro?.message || erro || '').slice(0, 2000)
    if (!mensagem || IGNORAR.test(mensagem) || vistos.has(mensagem) || vistos.size > 50) return
    vistos.add(mensagem)
    const token = getUserCachedData()?.token
    fetch(buildApiUrl('/erros'), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ mensagem, detalhe: String(detalhe || erro?.stack || '').slice(0, 4000), rota: window.location.pathname }),
    }).catch(() => {})
  } catch { /* nada */ }
}

export function observarErrosGlobais() {
  window.addEventListener('error', (e) => registrarErro(e.error || e.message))
  window.addEventListener('unhandledrejection', (e) => {
    // Falha de requisição já é registrada pelo servidor quando é erro dele
    if (e.reason?.isAxiosError) return
    registrarErro(e.reason)
  })
}
